import { Meter } from '../../platform/primitives/Meter'
import { envelopeSkin, meterSkin, shownPct } from './budgetRules'
import type { Envelope } from './budgetWire'
import './budget.css'

/**
 * The envelope's progress bar: the one bar M4's list and M2's Overview both draw.
 * The fill is the SERVER's percentage, clamped to the track visually; the meter's
 * value is not clamped, so `aria-valuenow` stays truthful at 150%. Skin precedence
 * over > close > spent, each a token fill in `budget.css`; the state is also
 * said in `aria-valuetext`, so colour is never the only signal.
 *
 * **Callers filter out paused envelopes.** The bar has no paused skin: a paused
 * envelope handed to it draws as if it were live.
 */
export function EnvelopeBar({ envelope, size = 'row' }: { envelope: Envelope; size?: 'row' | 'compact' }) {
  const now = shownPct(envelope)
  const state = envelopeSkin(envelope)
  const over = state === 'over'
  const text = `${now}% used${over ? ', over budget' : state === 'close' ? ', close to limit' : ''}`
  return (
    <Meter
      label={`${envelope.name} allowance used`}
      value={now}
      fill={envelope.progress.percentage}
      skin={meterSkin(state)}
      compact={size === 'compact'}
      className="env-bar-well"
      valueText={text}
    />
  )
}
